/* eslint-disable max-len */
import React from 'react';

import {VOTE_POSITIVE} from '../../constants';

import styles from './index.module.css';

export default ({openModal}) => (
  <div className={styles.wrapper}>
    <svg width="99" height="100" viewBox="0 0 99 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M63.5553 9.07021C45.1503 2.21814 23.7249 8.03928 11.2912 23.2142C-1.11269 38.3475 -2.79893 60.2376 7.3583 77.0162C17.4659 93.7214 37.3737 102.457 56.5227 98.6872C78.2159 94.4157 93.9031 74.8423 94.0667 52.8852C93.9229 33.4898 81.7868 15.8593 63.5553 9.07021Z" fill="#EFF3FE" />
      <path d="M67.0315 88.313C49.7177 94.4713 30.0432 89.1059 18.2147 75.0785C6.16306 60.7921 4.58591 39.7514 14.252 23.7836C23.824 7.96899 42.814 -0.390554 60.9461 3.31913C81.4191 7.50832 96.1886 25.8638 96.3423 46.663C96.2035 65.1296 84.5337 82.0852 67.0315 88.313ZM68.3061 2.84804C49.9062 -4.00403 28.481 1.8171 16.0474 16.992C3.6436 32.1253 1.95734 54.0154 12.1095 70.7941C22.222 87.4993 42.1296 96.2347 61.2784 92.465C82.9714 88.194 98.6584 68.6196 98.8221 46.663C98.6783 27.2677 86.5423 9.63714 68.3061 2.84804Z" fill="#1E54B7" />
      <path d="M49.2368 53.7976L41.3756 45.9363L38 49.3119L49.2368 60.5487L72.41 37.3756L69.0344 34L49.2368 53.7976Z" fill="#1E54B7" />
    </svg>

    <h4 className={styles.heading}>
      Ваш голос «{openModal.voteType === VOTE_POSITIVE ? 'ЗА' : 'ПРОТИВ'}» {openModal.name} засчитан
    </h4>
    <p className={styles.text}>Спасибо, что участвуете в голосовании!</p>
  </div>
);
